import _ from 'lodash';
import { createActionHelpers } from 'vuex-loading';

export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_TABLE_CTX = 'UPDATE_TABLE_CTX';
export const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA';
export const ADD_FILTER_TO_MODEL = 'ADD_FILTER_TO_MODEL';
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const UPDATE_SEARCHED_CLIENTS = 'UPDATE_SEARCHED_CLIENTS';
export const UPDATE_FIND_RESULT = 'UPDATE_FIND_RESULT';
export const submitSearchClientsAction = 'submitSearchClientsAction';
export const resetSearchedClientsAction = 'resetSearchedClientsAction';
export const setFilterAction = 'setFilterAction';
export const changeErrorStatus = 'changeErrorStatus';
export const createClientAction = 'createClientAction';
export const searchByFilterAction = 'searchByFilterAction';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});
function clientOperation(operations) {
  const matrix = {};
  _.forOwn(operations, (op, opKey) => {
    if (Array.isArray(op.clients) && op.clients.length > 0) {
      op.clients.forEach((c) => {
        if (!Array.isArray(matrix[c])) {
          matrix[c] = [];
        }
        matrix[c].push(opKey);
      });
    }
  });
  return matrix;
}

async function proyectClientFromOperation(rootGetters, clients) {
  const ops = await rootGetters['operation_model/entitiesGetter'];
  const matrix = clientOperation(ops);
  const result = [];
  if (Array.isArray(clients)) {
    clients.forEach((c) => {
      if (matrix[c.id]) {
        matrix[c.id].forEach(op => result.push({
          nombre: c.nombre ? c.nombre : c.title,
          dni: c.dni,
          operation: ops[op].title,
          operationId: ops[op].id,
          importe: ops[op].nexumImporte,
          id: c.id,
          direccion: c.direccion,
          title: c.title,
        }));
      }
    });
  }
  return result;
}

const initState = {
  error: '',
  loading: false,
  searchedClients: [],
  findResult: false,
  formModel: {
    filtro: '',
  },
  tableCtx: {
    currentPage: 1,
    perPage: 10,
    filter: '',
    sortBy: '',
    sortDesc: false,
  },
  tableData: [],
};

export default {
  namespaced: true,
  state: Object.assign({}, initState),
  mutations: {
    [CLEAR_MODULE](state) {
      Object.assign(state, initState);
    },
    [UPDATE_LOADING](state, loading) {
      state.loading = loading;
    },
    [UPDATE_ERROR](state, msg) {
      state.error = msg;
    },
    [UPDATE_TABLE_CTX](state, model) {
      state.tableCtx = Object.assign({}, state.tableCtx, model);
    },
    [ADD_FILTER_TO_MODEL](state, filter) {
      state.formModel.filtro = filter;
    },
    [UPDATE_TABLE_DATA](state, lista) {
      state.tableData = lista;
    },
    [UPDATE_SEARCHED_CLIENTS](state, lista) {
      state.searchedClients = lista;
    },
    [UPDATE_FORM_DATA](state, payload) {
      payload.filtro = state.formModel.filtro;
      state.formModel = payload;
    },
    [UPDATE_FIND_RESULT](state, payload) {
      state.findResult = payload;
    },
  },
  actions: {
    [submitSearchClientsAction]({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'buscar clientes');
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      commit(UPDATE_FORM_DATA, payload);
      const fetchConfig = {};
      let importeFilter;
      let typeImporteFilter;
      _.forOwn(payload, (value, key) => {
        if (value && value !== '') {
          if (key === 'nombre') {
            fetchConfig.or = {
              conjunction: 'OR',
            };
            fetchConfig.nombreFilter = {
              modelName: 'nombre',
              operator: 'CONTAINS',
              value,
              path: 'nombre',
              memberOf: 'or',
            };
            fetchConfig.apellidosFilter = {
              modelName: 'apellidos',
              operator: 'CONTAINS',
              value,
              path: 'apellidos',
              memberOf: 'or',
            };
          } else if (key === 'dni') {
            fetchConfig.dniFilter = {
              modelName: 'dni',
              operator: 'CONTAINS',
              value,
              path: 'dni',
            };
          } else if (key === 'importe') {
            importeFilter = {
              value,
              path: 'importe_ofrecido',
              parent: 'node--operation',
              parentProperty: 'clients',
            };
          } else if (key === 'condicionImporte') {
            typeImporteFilter = { operator: value };
          } else if (key === 'tipoOperacion') {
            fetchConfig.tipoOperacionFilter = {
              operator: '=',
              value,
              path: 'product.uuid',
              parent: 'node--operation',
              parentProperty: 'clients',
            };
          }
        }
      });
      if (importeFilter && typeImporteFilter) {
        fetchConfig.importeFilter = Object.assign({}, importeFilter, typeImporteFilter);
      }
      return dispatch('client_model/fetchAction', fetchConfig, { root: true })
        .then(results => proyectClientFromOperation(rootGetters, results.entities))
        .then((entities) => {
          if (entities.length <= 0) {
            commit(UPDATE_TABLE_DATA, []);
          } else {
            commit(UPDATE_TABLE_DATA, entities);
          }
          commit(UPDATE_FIND_RESULT, true);
          commit(UPDATE_LOADING, false);
          endLoading(dispatch, 'buscar clientes');
        })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscar clientes');
        });
    },
    [changeErrorStatus]({ commit }, msg) {
      commit(UPDATE_ERROR, msg);
    },
    [resetSearchedClientsAction]({ commit }) {
      commit(CLEAR_MODULE);
    },
    [createClientAction]({ commit, dispatch }, payload) {
      return dispatch('client_model/upsertEntityAction', payload.client, { root: true });
    },
    [setFilterAction]({ commit }, filter) {
      commit(ADD_FILTER_TO_MODEL, filter);
    },
    [searchByFilterAction]({ commit, dispatch, rootGetters }) {
      startLoading(dispatch, 'buscar clientes');
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      dispatch('operation_model/fetchAction', {
        uuid: {
          operator: 'IS NOT NULL',
          path: 'clients.uuid',
          parent: 'node--operation',
          parentProperty: 'clients',
        },
      }, { root: true }).then((res) => {
        const { entities } = res;
        if (Array.isArray(entities) && entities.length > 0) {
          proyectClientFromOperation(rootGetters, entities)
            .then((results) => {
              if (results.length <= 0) {
                commit(UPDATE_TABLE_DATA, []);
              } else {
                commit(UPDATE_TABLE_DATA, results);
              }
              commit(UPDATE_LOADING, false);
            });
        } else {
          commit(UPDATE_TABLE_DATA, []);
        }
        commit(UPDATE_LOADING, false);
        commit(UPDATE_FIND_RESULT, true);
        endLoading(dispatch, 'buscar clientes');
      })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscar clientes');
        });
    },
  },
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    existError: state => state.error !== '',
    searchedClients: state => state.tableData,
    findResult: state => state.findResult,
  },
};



// WEBPACK FOOTER //
// ./src/features/menu-clientes/store.js